<!--  -->
<template>
  <div class="box">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>检验检测服务</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content">
        <div class="content-box">
            <div class="top">
                <div class="left">
                    <img src="../../assets/img/jiliangnengli/icon.png" alt="">
                    <div class="text">
                        <div class="title">检测能力</div>
                        <div class="en-text">detectability</div>
                    </div>
                </div>
            </div>
            <div class="list">
                <div class="item" v-for="(item, index) in jiancenengliList" :key="index" @click="toDetail(item)">
                    <img class="img" :src="downloadUrl + item.photo" alt="">
                    <div class="info">
                        <div class="name">
                            <img src="../../assets/img/jiliangnengli/unit-icon.png" class="unit-icon" alt="">
                            <div>{{ item.name }}</div>
                        </div>
                        <!-- <div class="unit"></div> -->
                    </div>
                </div>
            </div>
            <div class="bottom">
                <el-pagination
                    layout="prev, pager, next"
                    :total="jiancenengliTotal"
                    @current-change="jiancenengliCurrentPage"
                    @prev-click="jiancenengliShang"
                    @next-click="jiancenengliXia"
                    :page-size="pageSize"
                >
                </el-pagination>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Server,httpurl } from "@/server";
export default {
  data () {
    return {
        jiancenengliList: [], // 检测能力列表
        jiancenengliTotal: 0, // 检测能力总数
        serviceList: [], // 检测服务方案列表
        serviceTotal: 0, // 检测服务方案总数

        pageSize: 8,
        pageNo: 1,
        downloadUrl: '',
    }
  },
  created() {
    this.getJiancenengliList()
    this.downloadUrl = this.$downloadUrl
  },
  methods: {
    getJiancenengliList() {
        Server.getJianyanjianceInfo({type: 1}).then(res => {
            console.log(res);
            if(res.success) {
                this.jiancenengliList = res.result.records
            }
        })
    },

    jiancenengliCurrentPage(page) {
        this.pageNo = page;
    },
    jiancenengliXia() {
        this.pageNo = this.pageNo + 1;
        this.getJiliangData(this.pageNo)
    },
    jiancenengliShang() {
        this.pageNo = this.pageNo - 1;
        this.getJiliangData(this.pageNo)
    },
  }
}
</script>

<style lang="less" scoped>

</style>
